import React from "react";
import herobg from "../Assets/Hero/herobg.jpg";
import Navbar from "./Header.jsx";
import SearchBox from "./SearchBox.jsx";

export default function NewHero() {
  return (
    <div>
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <div className="relative h-screen">
        {/* Background Image */}
        <img
          src={herobg}
          alt="Background"
          className="absolute inset-0 object-cover w-full h-full z-0"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-black opacity-50"></div>
        {/* Content */}
        <div className="absolute inset-0 flex flex-col justify-center items-center z-10 text-white px-4 md:px-8 lg:px-16">
          <a
            href="/form"
            className="inline-flex justify-between items-center py-1 px-1 pr-4 mb-7 text-sm text-white bg-white/20 rounded-full dark:bg-gray-800 dark:text-white hover:bg-white/30 dark:hover:bg-gray-700"
            role="alert"
          >
            <span className="text-xs bg-primary-600 rounded-full text-white px-4 py-1.5 mr-3">~</span>
            <span className="text-sm font-medium">Let's plan your trip with AI</span>
            <svg
              className="ml-2 w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              ></path>
            </svg>
          </a>

          <h1 className="mb-4 text-3xl font-extrabold text-center tracking-tight leading-none text-white md:text-4xl lg:text-5xl xl:text-6xl">
            Personalized Trips, Powered by AI
          </h1>
          <p className="mb-8 text-base text-center font-normal text-white sm:text-lg lg:text-xl sm:px-8 lg:px-16 xl:px-24">
            With{" "}
            <span className="text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-yellow-500 bg-clip-text">
              jetsetai
            </span>{" "}
            discover personalized travel itineraries crafted just for you.
          </p>

          <SearchBox />
        </div>
      </div>
    </div>
  );
}
